import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len, react/prop-types */
var Afterpay = function Afterpay(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    enableBackground: "new 0 0 1148.9 220.8",
    viewBox: "0 0 1148.9 220.8",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Afterpay Arrows Icon"
    }), /*#__PURE__*/_jsxs("g", {
      "aria-hidden": "true",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m1131.4 44.6-34.6-19.8-35.1-20.1c-23.2-13.3-52.2 3.4-52.2 30.2v4.5c0 2.5 1.3 4.8 3.5 6l16.3 9.3c4.5 2.6 10.1-.7 10.1-5.9v-10.7c0-5.3 5.7-8.6 10.3-6l32 18.4 31.9 18.3c4.6 2.6 4.6 9.3 0 11.9l-31.9 18.3-32 18.4c-4.6 2.6-10.3-.7-10.3-6v-5.3c0-26.8-29-43.6-52.2-30.2l-35.1 20.1-34.6 19.8c-23.3 13.4-23.3 47.1 0 60.5l34.6 19.8 35.1 20.1c23.2 13.3 52.2-3.4 52.2-30.2v-4.5c0-2.5-1.3-4.8-3.5-6l-16.3-9.3c-4.5-2.6-10.1.7-10.1 5.9v10.7c0 5.3-5.7 8.6-10.3 6l-32-18.4-31.9-18.3c-4.6-2.6-4.6-9.3 0-11.9l31.9-18.3 32-18.4c4.6-2.6 10.3.7 10.3 6v5.3c0 26.8 29 43.6 52.2 30.2l35.1-20.1 34.6-19.8c23.3-13.5 23.3-47.1 0-60.5z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m904.4 51.2-81 167.3h-33.6l30.3-62.5-47.7-104.8h34.5l30.6 70.2 33.4-70.2z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m94.5 110.6c0-20-14.5-34-32.3-34s-32.3 14.3-32.3 34c0 19.5 14.5 34 32.3 34s32.3-14 32.3-34m.3 59.4v-15.4c-8.8 10.7-21.9 17.3-37.5 17.3-32.6 0-57.3-26.1-57.3-61.3 0-34.9 25.7-61.5 58-61.5 15.2 0 28 6.7 36.8 17.1v-15h29.2v118.8z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m266 143.6c-10.2 0-13.1-3.8-13.1-13.8v-52.7h18.8v-25.9h-18.8v-29h-29.9v29h-38.6v-11.8c0-10 3.8-13.8 14.3-13.8h6.6v-23h-14.4c-24.7 0-36.4 8.1-36.4 32.8v15.9h-16.6v25.8h16.6v92.9h29.9v-92.9h38.6v58.2c0 24.2 9.3 34.7 33.5 34.7h15.4v-26.4z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m373.4 99.9c-2.1-15.4-14.7-24.7-29.5-24.7-14.7 0-26.9 9-29.9 24.7zm-59.7 18.5c2.1 17.6 14.7 27.6 30.7 27.6 12.6 0 22.3-5.9 28-15.4h30.7c-7.1 25.2-29.7 41.3-59.4 41.3-35.9 0-61.1-25.2-61.1-61.1s26.6-61.8 61.8-61.8c35.4 0 61.1 26.1 61.1 61.8 0 2.6-.2 5.2-.7 7.6z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m595.9 110.6c0-19.2-14.5-34-32.3-34s-32.3 14.3-32.3 34c0 19.5 14.5 34 32.3 34s32.3-14.7 32.3-34m-94.1 107.9v-167.3h29.2v15.4c8.8-10.9 21.9-17.6 37.5-17.6 32.1 0 57.3 26.4 57.3 61.3s-25.7 61.5-58 61.5c-15 0-27.3-5.9-35.9-15.9v62.5z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m731.1 110.6c0-20-14.5-34-32.3-34s-32.3 14.3-32.3 34c0 19.5 14.5 34 32.3 34s32.3-14 32.3-34m.3 59.4v-15.4c-8.8 10.7-21.9 17.3-37.5 17.3-32.6 0-57.3-26.1-57.3-61.3 0-34.9 25.7-61.5 58-61.5 15.2 0 28 6.7 36.8 17.1v-15h29.2v118.8z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m449.1 62.8s7.4-13.8 25.7-13.8c7.8 0 12.8 2.7 12.8 2.7v30.3s-11-6.8-21.1-5.4-16.5 10.6-16.5 23v70.3h-30.2v-118.7h29.2z"
      })]
    })]
  });
};

export default Afterpay;